import { PromotionSegmentationType } from "../../../../models/enums/promotions/promotion_segmentation_type.enum";

export const PROMOTION_SEGMENTATION_TYPE_OPTIONS = [
    { value: PromotionSegmentationType.ALL_STUDENTS, viewValue: 'Todos los alumnos' },
    { value: PromotionSegmentationType.COURSE_ENROLLMENT, viewValue: 'Alumnos matriculados y NO matriculados en:' },
    { value: PromotionSegmentationType.SPECIFIC_STUDENTS, viewValue: 'Alumnos en particular' },
  ]
